import React from 'react'
import { titleText } from '../constant/common_use';

export const Step = ({ stepNumber, currentStep, children }) => (
    <div style={{ display: currentStep === stepNumber ? 'block' : 'none' }}>
        {children}
    </div>
);

const StepIndicator = React.forwardRef(({ stepNumber, currentStep, setCurrentStep, isAdmin, isScrolledToBottom }, ref) => {
    //const isDisabled = (!isAdmin && !isScrolledToBottom && currentStep === 2 && stepNumber > 2) || (!isAdmin && !isScrolledToBottom && currentStep > 2 && stepNumber > 1);
    const isDisabled = !isAdmin && (
        (currentStep === 1 && stepNumber !== 2) || // Only allow step 2 to be clicked from step 1
        (currentStep === 2 && !isScrolledToBottom && stepNumber !== 1) || // Only allow step 1 to be clicked from step 2 if not scrolled to bottom
        (currentStep > 2 && !isScrolledToBottom) // Prevent navigation if not scrolled to bottom and current step is greater than 2
    );

    return (
        <div
            ref={ref}
            style={{
                display: 'inline-block',
                textAlign: 'center',
                minWidth: '100px',
                width: '8%'
            }}
        >
            <button
                onClick={() => setCurrentStep(stepNumber)}
                disabled={isDisabled}
                style={{
                    width: '70px',
                    height: '70px',
                    margin: '10px',
                    backgroundColor: currentStep === stepNumber ? '#fff' : '#6f42c1',
                    color: currentStep === stepNumber ? '#6f42c1' : '#fff',
                    border: '2px solid #6f42c1',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '32px',
                    fontWeight: 'bold',
                }}
            >
                {stepNumber}
            </button>
            <p
                style={{
                    color: '#6f42c1',
                    fontSize: '12px',
                    marginTop: '5px',
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word',
                }}
            >
                {titleText[stepNumber - 1]}
            </p>
        </div>
    );
});

export default StepIndicator